import { useState } from 'react';
import { track } from '../../../utils/track';
import {
  PurchasePackagesType,
  SelectedPurchaseType,
  SubscriptionPackagesType
} from '../../../types/types';

export const usePurchaseModal = () => {
  const [isBuyModalOpen, setIsBuyModalOpen] = useState<boolean>(false);
  const [selectedPurchase, setSelectedPurchase] =
    useState<SelectedPurchaseType | null>(null);
  const [showFinalUpsell, setShowFinalUpsell] = useState<boolean>(false);

  const handlePurchaseModalClose = () => {
    setSelectedPurchase(null);
    setIsBuyModalOpen(false);
    setShowFinalUpsell(false);
  };

  const handlePurchaseSelection = (
    packageData: PurchasePackagesType | SubscriptionPackagesType
  ) => {
    setSelectedPurchase({ ...packageData });
    setIsBuyModalOpen(true);
    // Funnel entry — the denominator for payment_failed / abandonment analysis
    // in the CRM. (checkout_abandon on close is a follow-up: it needs a success
    // flag threaded through both the standalone and subscription success paths.)
    const pkg = packageData as { id?: number; name?: string; type?: string };
    track('purchase.checkout_start', { packageId: pkg.id, name: pkg.name, type: pkg.type }, { category: 'checkout' });
  };

  const handleBonusPurchaseSuccess = () => {
    setShowFinalUpsell(true);
  };

  return {
    isBuyModalOpen,
    selectedPurchase,
    showFinalUpsell,
    handlePurchaseModalClose,
    handlePurchaseSelection,
    handleBonusPurchaseSuccess
  };
};
